var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailEmailLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7794 18.0459H6.65662C4.98168 18.0459 3.625 16.7092 3.625 15.0629V7.80136C3.625 6.15507 4.98168 4.81836 6.65662 4.81836H18.7813C20.4544 4.81836 21.8129 6.15328 21.8129 7.80136V15.0629C21.8111 16.7092 20.4544 18.0459 18.7794 18.0459Z",
    fill: "#3158F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15625 4.44141C5.03607 5.24676 9.6535 9.68768 11.3621 11.2446C12.2392 12.0444 13.581 12.0458 14.458 11.246C16.2273 9.63252 20.8006 5.23159 21.6639 4.44141",
    stroke: "white",
    strokeWidth: 1.67185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.4102C15.7118 12.6416 20.696 17.4935 21.6655 18.4161",
    stroke: "white",
    strokeWidth: 1.67185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5575 11.4102C10.0957 12.6416 5.11008 17.4935 4.14062 18.4161",
    stroke: "white",
    strokeWidth: 1.67185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8281,
    cy: 5.06634,
    r: 4.17962,
    fill: "#3158F2",
    stroke: "white",
    strokeWidth: 1.17029
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailEmailLetter);
export default __webpack_public_path__ + "static/media/Mail-Email-Letter.322f3fff2b3b79c88488062cd1c42aef.svg";
export { ForwardRef as ReactComponent };